export const RoutePostMerchflowStorePog_storePogId_MarkDelivered =
  "/merchflow/store/pog/:storePogId/mark-delivered";

export interface ParamsPostMerchflowStorePog_storePogId_MarkDelivered {
  storePogId: string;
}

export type ResponsePostMerchflowStorePog_storePogId_MarkDelivered =
  { status: "delivered" } | { status: "already_delivered" };
